export const handleSmoothScroll = (
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  offset: number = 80
) => {
  if (href.startsWith("#")) {
    e.preventDefault();
    const targetElement = document.querySelector(href);
    if (targetElement) {
      if (typeof window !== "undefined") {
        const elementPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  } else {
    window.location.href = href;
  }
};
